import { gql } from "@apollo/client";


export const IS_PRODUCT_ADDED_TO_IDEA = gql`
    query IsProductAddedToIdea($ideaId: ID!) {
        idea(id: $ideaId) {
            products {
                id
                name
            }
        }
    }
`;

export const INFER_PRODUCT_CHARACTERISTICS_FROM_DESCRIPTION = gql`
    query InferProductCharacteristics($description: String!) {
        productCharacteristics(description: $description)
    }
`;

export const FIND_MATCHING_PRODUCTS_TO_DESCRIPTION = gql`
    query FindMatchingProductsToDescription($description: String!) {
        findProductsByDescription(description: $description) {
            kNumber
            deviceName
            productCode
            productCodeDescription
            intendedUse
            indicationsForUse
            regulationNumber
            medicalSpecialty
            deviceClass
            primaryPredicateKNumber
            characteristics {
                name
                value
            }
        }
    }
`;
